import { FETCH_TIP_REPORT_RES } from '../actions/types';

const tipReportReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_TIP_REPORT_RES:
      return action.payload;
    default:
      return state;
  }
};

export default tipReportReducer;
